import * as React from 'react';
import {connect} from 'react-redux';
import {Popover, Switch, WithStyles, withStyles,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import { applyChanges } from './CleardaysCalc';
import { IFamilyMember } from '@app-types/websocket/family.types';
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";
import VVFullDatePicker from '@components/common/timepicker/VVFullDatePicker';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();



interface IState {
  clearDays:Date
  clear:"BEFORE"|"AFTER";
  edit:boolean;
}

interface IProps extends WithStyles<typeof EditActionStyle> {
  family:IFamilyMember[];
  scheduleEditBase:ISchedule|undefined; 
  scheduleEditPreview:ISchedule|undefined; 
  updatePreview:(schedule:ISchedule) => void;
  updateBase:(schedule:ISchedule) => void;
  close:(finished:boolean) => void;
}

class Cleardays extends React.Component<IProps, IState> {
  private dateRef:React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);
    
    this.state = {
      clearDays:new Date(),
      clear:"AFTER", 
      edit:false,
    };

  }

  public componentDidMount(): void {
    this.update();
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevState.clear !== this.state.clear || prevState.clearDays !== this.state.clearDays) {
      this.update();
    }
  }

  public render() {
    const {classes, family, scheduleEditBase} = this.props;

    return (<>
      <div className={classes.paneOptions} >
        <Button className={classes.paneOption} style={{textAlign: 'start'}}  startIcon={<BackArrowIcon />} classes={{text:classes.backButton}}
          onClick={() => {
          if (this.props.scheduleEditBase) {
            this.props.updatePreview(this.props.scheduleEditBase);  
          }
          this.props.close(false);
        }}>
          {tn.lang.back}
        </Button>
        <div className={classes.paneOption+" "+classes.paneCenter} > 
          <div style={{fontSize:'10px'}}>{""}</div>
        </div>
        <Button className={classes.paneOption} variant="contained" color="primary" style={{textAlign: 'end', marginRight:'10px'}} 
          disabled={false} onClick={() => this.execute()} classes={{contained:classes.buttonContained}} >
          {tn.lang.save}
        </Button>
      </div>
      <div className={classes.pane} style={{gap: '16px', paddingTop: '16px'}}>
        
        <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}}>
          Clear all days
        </div>
        <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}} 
          onClick={() => this.setState({clear:this.state.clear==="AFTER"?"BEFORE":"AFTER"})}>
          <span style={this.state.clear === "AFTER"?{}:{fontWeight:600}}>Before</span>
          <Switch color="default" readOnly={true} checked={(this.state.clear === "AFTER")}/>
          <span style={this.state.clear === "AFTER"?{fontWeight:600}:{}}>After</span>
        </div>
        <div ref={this.dateRef} onClick={() => this.setState({edit:true})} style={{fontSize: '26px', fontWeight: 600, 
            padding: '8px',display: 'flex',alignItems: 'center', alignSelf: 'center',
            backgroundColor: styleColors.greyLight2, border: `1px solid ${styleColors.greyMedium1}`, borderRadius: '4px'}}>
          {tn.formatDateDayMonthYear(this.state.clearDays)} 
        </div>
        <Popover 
          anchorEl={this.dateRef.current}
          onClose={() => {this.setState({edit:false})}}
          open={(this.state.edit)}
          disableScrollLock={true}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <VVFullDatePicker
            open={(this.state.edit)}
            date={this.state.clearDays}
            setDate={(date:Date) => this.setState({clearDays:date})}
          />
        </Popover>
      </div>
      </>
    );
  }

  private execute() {
    if (this.props.scheduleEditBase) {
      this.props.updateBase(applyChanges(this.props.scheduleEditBase, this.state.clear==="BEFORE"?this.state.clearDays:undefined, 
        this.state.clear==="BEFORE"?undefined:this.state.clearDays));
      this.props.close(true);
    }
  }

  private update() {
    if (this.props.scheduleEditBase) {
      this.props.updatePreview(applyChanges(this.props.scheduleEditBase, this.state.clear==="BEFORE"?this.state.clearDays:undefined,
        this.state.clear==="BEFORE"?undefined:this.state.clearDays));
    }
  }
}

function mapStateToProps(state: any) {

  return {
    family:state.family.family,
  };
}

export default connect(mapStateToProps)(withStyles(EditActionStyle)(Cleardays));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Cleardays/Cleardays.tsx